import React, {useState} from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Layout from '../../components/Layout'
import styled from 'styled-components'
import { Card } from 'antd';
import Button from '../../components/Button'
import constants from '../../config/constants'
import Modal from '../../components/Modal'
import background from '../../assets/images/background.png'
import logo from '../../assets/images/groupLogoMarketing.svg'

const Background = styled.div`
  height: 100%;
  margin: 0 -15px;
  width: auto;
`

const StyledImg = styled.img`
  min-height: 350px;
  width: 100%;
  object-fit: cover;
  object-position: center;
`

const Main = styled.div`
  margin-top: -8rem;
  text-align: center;
`

const Contant = styled(Card)`
  border-radius: 15px !important;
  border: none !important;
  -webkit-box-shadow: 0px -70px 74px -5px #00000040 !important;
  -moz-box-shadow: 0px -70px 74px -5px #00000040 !important;
  box-shadow: 0px -70px 74px -45px #00000040 !important;

  .ant-card-body {
    padding: 15px !important;
  }
`

const Title = styled.p`
  font-size: 30px;
  line-height: 40.5px;
  color: ${constants.color.dark};
`

const Description = styled.p`
  font-size: 18px;
  line-height: 24.3px;
  color: ${constants.color.dark};
`

const MainModal = styled.div`
  padding: 0 15px;
`

const ModalDetail = styled.div`
  color: ${constants.color.dark} !important;
  margin: 1.5rem 0;
`

const TitleModal = styled.h4`
  text-align: center;
`

const Bullet = styled.p`
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
  padding: 0 0.5rem;
`

const Marketing = (props) => {

  const [openModal, setOpenModal] = useState(false);

  return (
    <Layout title={'กองทุนรวม'} closeIcon={true}>
      <Background>
        <StyledImg src={background}/>
      </Background>
      <Main>
        <Contant>
          <Title>การลงทุน</Title>
          <Description>ซื้อ ขาย และจัดการกองทุนรวมของคุณง่าย แค่ปลายนิ้ว ทุกที่ทุกเวลา</Description>
          <LazyLoadImage
            style={{ marginTop: '2rem', marginBottom: '1.5rem'}}
            alt=''
            visibleByDefault={true}
            height={'50%'}
            src={logo}
            width={'auto'} />
          <Button
            textcolor={constants.color.white}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'สนใจสมัคร'}
            disabled={false}
            onClick={() => props.history.push('/condition')}/>
        </Contant>
      </Main>
      <Modal visible={openModal}>
        <MainModal>
          <TitleModal>ขออภัยไม่สามารถเปิดบัญชีได้<br/>เนื่องจากเหตุผลดังต่อไปนี้</TitleModal>
          <ModalDetail>
            <Bullet>ไม่ใช่สัญชาติไทย</Bullet>
            <Bullet>บัตรประชาชนหมดอายุ</Bullet>
            <Bullet>อายุน้อยกว่า 20 หรือ มากกว่า 60</Bullet>
          </ModalDetail>
          <Button
            textcolor={'#fff'}
            bordercolor={constants.color.orange}
            backgroundcolor={constants.color.orange}
            text={'ตกลง'}
            disabled={false}
            onClick={() => setOpenModal(!openModal)}/>
        </MainModal>
      </Modal>
    </Layout>
  )
}

export default Marketing
